<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <v-row class="align-center" no-gutters>
        <v-col cols="12" sm="12" md="5" class="">
          <span class="text-h5 font-weight-bold ml-3 full-width page-header">
            {{ $t("menu.documents") }}
            <v-btn icon x-small class="mx-2 mb-1" @click="openManual()">
              <v-icon color="#404040">mdi-alert-circle-outline</v-icon>
            </v-btn>
          </span>
        </v-col>
        <v-col cols="12" sm="12" md="7" class="">
          <v-tabs
            class="a-tabs document-tabs"
            v-model="selectedTab"
            show-arrows
            height="38"
            style="background-color: var(--v-Neutral-base) !important"
            right
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              href="#tab-0"
              v-if="$security.checkUserAccess('ViewDirectory')"
            >
              {{ $t("documents.documentByFolder") }}
            </v-tab>
            <v-tab href="#tab-1">
              {{ $t("documents.documentByAgenda") }}
            </v-tab>
            <v-tab href="#tab-2">
              {{ $t("documents.documentByMeeting") }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
    </template>
    <template v-slot:page-content>
      <v-card flat tile outlined style="width: 100%">
        <v-card-text class="ma-0">
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
              <v-tabs-items v-model="selectedTab">
                <v-tab-item
                  value="tab-0"
                  v-if="$security.checkUserAccess('ViewDirectory')"
                >
                  <document-explorer
                    v-if="selectedTab == 'tab-0'"
                  ></document-explorer>
                </v-tab-item>
                <v-tab-item value="tab-1">
                  <document-by-agenda
                    v-if="selectedTab == 'tab-1'"
                  ></document-by-agenda>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <document-by-meetings
                    v-if="selectedTab == 'tab-2'"
                  ></document-by-meetings>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </page-container>
</template>

<script>
import { mapActions } from "vuex";
import DocumentByAgenda from "./DocumentByAgenda.vue";
import DocumentByMeetings from "./DocumentByMeetings.vue";
import DocumentExplorer from "./DocumentExplorer.vue";
import Loader from "@/components/Loader";

export default {
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
      loaderLoading: false,
      activeComponent: null,
      selectedTab: this.$security.checkUserAccess("ViewDirectory")
        ? "tab-0"
        : "tab-1",
    };
  },
  components: {
    DocumentExplorer,
    DocumentByAgenda,
    DocumentByMeetings,
    Loader,
  },
  async mounted() {
    this.loaderLoading = true;
    try {
      this.activeComponent = DocumentExplorer;
      this.loaderLoading = false;
    } catch (error) {
      this.loaderLoading = false;
    }
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
  },
  methods: {
    ...mapActions({
      getMeetingListApi: "document/getMeetingListForDocument",
      getDirectoryListApi: "directory/getDirectoryList",
    }),
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: "/usermanual",
        query: { content: this.$i18n.locale == "en" ? "Manual_E_Document.pdf" : "Manual_J_Document.pdf", id: this.$route.name },
      });
      let popup;
      if (
        routeData &&
        (typeof this.manualWindow === "undefined" ||
          this.manualWindow.closed ||
          this.manualClick === 1)
      ) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      } else {
        this.manualWindow.focus();
      }
    },
  },
};
</script>

<style scoped>
.document-tabs .v-tab--active {
  background: #dde3ee;
}
::v-deep.document-tabs a.v-tab {
  min-width: 240px;
}
.v-toolbar__content > .document-tabs:last-child {
  margin-right: 0px !important;
}
::v-deep .theme--light.document-tabs > .v-tabs-bar {
  background: transparent !important;
}
::v-deep .v-slide-group__wrapper {
  contain: content;
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  background-color: #f4f4f4 !important;
}

::v-deep .v-card__text {
  padding: 12px !important;
}
::v-deep .theme--dark.v-tabs > .v-tabs-bar {
  background: transparent !important;
}
.title-text {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 62px;
  text-transform: uppercase;
  color: var(--v-darkCharcoal-base);
}
</style>